<elcia-card>
  <div class="flex h-full min-w-0 flex-col gap-3">

    <div class="flex min-w-0 items-center gap-2.5">
      <span aria-hidden="true" class="pi pi-check-square flex-none text-sm text-[var(--p-surface-400)]"></span>
      <span class="min-w-0 text-lg font-bold">{{ 'dashboard.todos.title' | translate }}</span>
      @if (pendingCount() > 0) {
        <span class="flex-none rounded-full bg-[var(--p-surface-200)] px-2.5 py-0.5 text-xs tabular-nums text-[var(--p-surface-600)]">
          {{ pendingCount() }}
        </span>
      }
    </div>

    @if (pending.hasPending()) {
      <div [animate.enter]="'slide-in-top'"
           [animate.leave]="'slide-out-top'"
           class="flex items-center justify-between rounded-lg border-4 border-emerald-500 bg-emerald-50 p-2">
        <span class="text-sm">{{ 'todo.marked-completed' | translate }}</span>
        <elcia-button
          (click)="pending.cancelCompletion()"
          label="{{ 'action.cancel' | translate }} {{ pending.countdown() }}s"
          severity="secondary"/>
      </div>
    }

    <!-- The breakdown and the list share one card: the doughnut answers "how much and how urgent",
         the list answers "what do I do now". Side by side once the card is wide enough. -->
    <div class="flex min-w-0 flex-1 flex-col gap-4 lg:flex-row lg:gap-6">

      <div class="lg:w-44 lg:flex-none">
        <elcia-dashboard-todo-priority-chart/>
      </div>

      <div class="flex min-w-0 flex-1 flex-col gap-3">
        @if (isLoading()) {
          <div class="flex flex-1 items-center justify-center py-8">
            <elcia-loader/>
          </div>
        } @else if (groups().length === 0) {
          <div class="flex flex-1 flex-col items-center justify-center gap-2 py-8 text-[var(--p-surface-500)]">
            <span aria-hidden="true" class="pi pi-check-circle text-xl"></span>
            <span class="text-sm">{{ 'dashboard.todos.empty' | translate }}</span>
          </div>
        } @else {
          @for (group of groups(); track group.labelKey) {

            <!-- The group header carries the urgency, so each row below it no longer has to repeat it
                 and fits on a single line. -->
            <div class="flex items-baseline justify-between gap-2 border-b border-[var(--p-surface-200)] pb-1">
              <span class="text-[0.7rem] font-semibold tracking-wide text-[var(--p-surface-500)] uppercase">
                {{ group.labelKey | translate }}
              </span>
              <span class="text-xs tabular-nums text-[var(--p-surface-400)]">{{ group.todos.length }}</span>
            </div>

            @for (todo of group.todos; track todo.id) {
              <div class="flex min-w-0 items-center gap-2">
                <p-checkbox (click)="$event.stopPropagation()"
                            (onChange)="pending.toggleCompletion($event.originalEvent, todo)"
                            [binary]="true"
                            [formControl]="pending.getCompletionControl(todo)"
                            class="flex-none"/>

                <span [style.background-color]="todo.priorityColor ?? 'var(--p-surface-300)'"
                      aria-hidden="true"
                      class="h-2 w-2 flex-none rounded-full"></span>

                <span (click)="openTodo(todo)"
                      [title]="todo.title"
                      class="min-w-0 flex-1 cursor-pointer truncate text-sm hover:underline">
                  @if (todo.parentTitle) {
                    <span class="text-[var(--p-surface-500)]">{{ todo.parentTitle }}</span>
                    <span aria-hidden="true" class="text-[var(--p-surface-400)]">&nbsp;›&nbsp;</span>
                  }
                  {{ todo.title }}
                </span>

                @if (todo.concernName) {
                  <span class="hidden max-w-32 flex-none truncate text-xs text-[var(--p-surface-500)] sm:block">
                    {{ todo.concernName }}
                  </span>
                }

                <span [class]="todo.dueDate | dueDateClass"
                      [title]="todo.dueDate | dueDateFull"
                      class="flex-none text-xs tabular-nums">
                  {{ todo.dueDate | dueDateFormat }}
                </span>
              </div>
            }
          }

          @if (pendingCount() > todos().length) {
            <a [routerLink]="todosLink" class="mt-auto self-end text-xs text-primary-500 hover:underline">
              {{ 'dashboard.todos.see-all' | translate: {count: pendingCount()} }}
            </a>
          }
        }
      </div>
    </div>
  </div>
</elcia-card>
